var map = {
	"./1.png": 3880,
	"./15.png": 2987,
	"./16.png": 7877,
	"./2.png": 1981,
	"./3.png": 7582,
	"./4.png": 3191,
	"./WhatsApp Image 2025-03-15 at 2.04.37 PM.jpeg": 7766,
	"./a-1.png": 9484,
	"./a-2.png": 9428,
	"./a-3.png": 9871,
	"./a-4.png": 2128,
	"./a1.png": 9466,
	"./a2.png": 7102,
	"./about1.jpg": 3056,
	"./aboutfinal.jpeg": 347,
	"./aboutfinal.jpg": 8793,
	"./an.jpg": 4585,
	"./anchorlogo.png": 2109,
	"./ar.jpg": 9837,
	"./ar.png": 1179,
	"./bell-push.png": 1177,
	"./dB.png": 7798,
	"./dwb.png": 4897,
	"./edge-smart-panel.png": 4607,
	"./enq.png": 2874,
	"./enquire.png": 2196,
	"./footer.avif": 1410,
	"./g1.png": 1584,
	"./g2.png": 8796,
	"./g3.png": 1959,
	"./g4.png": 7907,
	"./g5.png": 2073,
	"./g6.png": 5208,
	"./g7.png": 8959,
	"./g8.png": 4974,
	"./g9.png": 6038,
	"./l1.jpeg": 3609,
	"./l1.jpg": 9747,
	"./l1.png": 5160,
	"./l1.webp": 7985,
	"./l10.png": 8189,
	"./l11.png": 5722,
	"./l12.png": 8876,
	"./l13.png": 4478,
	"./l14.png": 1946,
	"./l15.png": 4778,
	"./l16.png": 5911,
	"./l17.png": 9300,
	"./l18.png": 6292,
	"./l19.png": 2324,
	"./l2.png": 6734,
	"./l20.png": 380,
	"./l21.png": 6456,
	"./l3.png": 640,
	"./l4.png": 5288,
	"./l5.png": 323,
	"./l6.png": 835,
	"./l7.png": 7873,
	"./l8.png": 8286,
	"./l9.png": 5947,
	"./light.jpeg": 8354,
	"./light.jpg": 8773,
	"./lightingbanner.png": 3394,
	"./logo.jpg": 8820,
	"./luxe-fan-regulator.png": 5473,
	"./penta-flat.png": 2961,
	"./polycab.png": 3637,
	"./pro.jpg": 2808,
	"./pro.png": 8132,
	"./re.png": 7397,
	"./roma-classic.jpg": 4889,
	"./roma.png": 1110,
	"./seating.jpg": 9420,
	"./ss1.png": 4737,
	"./ss10.png": 6722,
	"./ss11.png": 6608,
	"./ss12.png": 3829,
	"./ss13.png": 6863,
	"./ss14.png": 4829,
	"./ss2.png": 2190,
	"./ss3.png": 5098,
	"./ss4.png": 545,
	"./ss5.png": 2839,
	"./ss6.png": 1345,
	"./ss7.png": 5816,
	"./ss8.png": 2707,
	"./ss9.png": 7880,
	"./ssl1.png": 9790,
	"./ssl2.png": 7375,
	"./swi.jpg": 6632,
	"./swi.png": 4782,
	"./swi.webp": 329,
	"./switched-socket.png": 5968,
	"./switches-banner.png": 415,
	"./turbo-lights.png": 925,
	"./turbodb.png": 4171,
	"./w1.png": 6449,
	"./w10.png": 4751,
	"./w11.png": 6243,
	"./w12.png": 7220,
	"./w2.png": 1697,
	"./w3.png": 2112,
	"./w4.png": 5428,
	"./w5.png": 2549,
	"./w6.png": 2493,
	"./w7.png": 2473,
	"./w8.png": 2885,
	"./w9.png": 9994,
	"./wbp.png": 2253,
	"./wbp1.png": 9815,
	"./wires.png": 752,
	"./wnw.jpg": 8450,
	"./wnw.png": 7412,
	"./wnw1.png": 2814,
	"./wnw2.png": 1525,
	"./wp1.png": 1588,
	"./wp2.png": 4752,
	"./wp3.png": 3618,
	"./wp4.png": 1197,
	"./wp5.png": 6627,
	"./wp6.png": 6351,
	"./wp7.png": 6749,
	"./wp8.png": 9457,
	"./wpl.png": 2845
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3219;